import { Controller } from "stimulus";
import InfiniteScroll from "infinite-scroll";

export default class InfiniteScrollsController extends Controller {
  container: InfiniteScroll;

  connect() {
    this.container = new InfiniteScroll(this.element, {
      path: () => {
        const nextButton = this.element.parentElement?.querySelector(
          ".pagination__next"
        ) as HTMLButtonElement | null;

        return nextButton?.dataset.nextUrl || undefined;
      },
      append: false,
      button: ".view-more-button",
      status: ".page-load-status",
      loadOnScroll: false,
      history: false,
      responseBody: "text",
      domParseResponse: false,
    });

    this.container.on("load", (body: string) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(body, "text/html");
      const newArticles = doc.querySelectorAll(".article");

      const wrapper = this.element.parentElement;
      const viewMoreWrapper = wrapper?.querySelector(".view-more-button")
        ?.parentElement as HTMLElement | null;
      const nextButton = wrapper?.querySelector(
        ".pagination__next"
      ) as HTMLButtonElement | null;
      const viewMoreButton = wrapper?.querySelector(
        ".view-more-button"
      ) as HTMLButtonElement | null;

      if (!viewMoreWrapper || !nextButton) return;

      newArticles.forEach((article) => {
        viewMoreWrapper.insertAdjacentElement("beforebegin", article);
      });

      const currentUrl = nextButton.dataset.nextUrl;
      if (!currentUrl) return;

      const url = new URL(currentUrl, window.location.origin);
      const currentPage = Number(url.searchParams.get("page") || "2");

      if (currentPage >= 10) {
        nextButton.remove();
        viewMoreButton?.classList.add("d-none");
        return;
      }

      url.searchParams.set("page", String(currentPage + 1));
      nextButton.dataset.nextUrl = `${url.pathname}${url.search}`;
    });
  }
}
